import { Box, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Row, Text } from '@/components/ui/primitives';
import { MobileButton } from '@/components/ui/widgets';
import {
  MaterialsAndPricingTable,
  type QuantityAndPrice,
  AddMaterialsModal,
} from '../components';

interface MaterialsSectionProps {
  localSiteMaterials: QuantityAndPrice[];
  loading: boolean;
  addMaterialsOpenModal: boolean;
  project: any;
  materials: any[];
  onChangeSiteMaterials: (data: QuantityAndPrice[]) => Promise<void>;
  onUpdateMaterial: (materialId: number, quantity: number) => Promise<void>;
  onDeleteMaterial: (materialId: number) => Promise<boolean>;
  onDeleteMaterials: (materialIds: number[]) => Promise<boolean>;
  openAddMaterialsModal: () => void;
  addAllMaterials: () => void;
  handleCloseMaterialsModal: () => void;
  handleSaveMaterials: (newList: QuantityAndPrice[]) => void;
}

export const MaterialsSection: React.FC<MaterialsSectionProps> = ({
  localSiteMaterials,
  loading,
  addMaterialsOpenModal,
  project,
  materials,
  onChangeSiteMaterials,
  onUpdateMaterial,
  onDeleteMaterial,
  onDeleteMaterials,
  openAddMaterialsModal,
  addAllMaterials,
  handleCloseMaterialsModal,
  handleSaveMaterials,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Divider sx={{ mt: '1.125rem' }} />

      {/* Materials and Pricing Table */}
      <MaterialsAndPricingTable
        onChangeSiteMaterials={onChangeSiteMaterials}
        onUpdateMaterial={onUpdateMaterial}
        onDeleteMaterial={onDeleteMaterial}
        onDeleteMaterials={onDeleteMaterials}
        localSiteMaterials={localSiteMaterials}
        loading={loading}
      />

      {/* Material Action Buttons */}
      <Row
        sx={{
          opacity: loading ? 0.5 : 1,
        }}
      >
        <MobileButton
          disabled={!project?.materialFormat?.id}
          btnColor='info.main'
          onClick={openAddMaterialsModal}
        >
          <Box sx={{ mx: '0.375rem', fontSize: '1rem' }}>➕</Box>
          <Text
            sx={{ color: 'black' }}
          >{`${t('add_item_button_edit_site')}`}</Text>
        </MobileButton>
        <Box sx={{ width: '2.5rem' }}></Box>
        <MobileButton
          disabled={true}
          btnColor='info.main'
          onClick={addAllMaterials}
        >
          <Row sx={{ mx: '0.375rem' }}>
            <Box sx={{ mx: '0.125rem', fontSize: '1rem' }}>➕</Box>
            <Box sx={{ fontSize: '1rem' }}>➕</Box>
          </Row>
          <Text
            sx={{ color: 'black' }}
          >{`${t('add_all_button_edit_site')}`}</Text>
        </MobileButton>
      </Row>

      {/* Add Materials Modal */}
      {addMaterialsOpenModal && (
        <AddMaterialsModal
          closeMaterials={handleCloseMaterialsModal}
          saveMaterials={handleSaveMaterials}
          localSiteMaterials={localSiteMaterials}
          availableMaterials={materials.filter(
            item => item.materialFormatId == project?.materialFormat?.id
          )}
        />
      )}
    </>
  );
};
